module.exports = __webpack_public_path__ + "static/img/amazon.f91deb6b.png";